(function(){
  'use strict';
  async function loadRelated(node){
    if(node.dataset.relatedLoaded)return;
    node.dataset.relatedLoaded='true';
    try{
      const url=new URL(node.dataset.url,location.href);
      if(url.origin!==location.origin)return;
      const response=await fetch(url.href,{credentials:'same-origin'});
      if(!response.ok)return;
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const result=Array.from(html.querySelectorAll('[data-ee-recommendations]')).find(item=>item.dataset.sectionId===node.dataset.sectionId);
      const content=result?.querySelector('[data-related-content]');
      if(!content||content.hidden||!content.querySelector('.ee-card'))return;
      node.replaceChildren(document.importNode(content,true));
    }catch{}
  }
  document.querySelectorAll('[data-ee-recommendations]').forEach(node=>{
    if('IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();loadRelated(node);}},{rootMargin:'400px'});
      observer.observe(node);
    }else loadRelated(node);
  });
})();
